import Slider, { SliderProps } from './Slider';

export type { SliderProps };
export default Slider;
